import { z } from 'zod'

export const GetLoadCustomAttributesSchema = z.object({
  export: z.string().nullish(),
  import: z.string().nullish(),
  ipaff: z.string().nullish(),
})

export const GetLoadSchema = z.object({
  created_at: z.coerce.date(),
  currency: z.string().nullish(),
  customs: z.boolean(),
  destination_distance: z.number().nullish(),
  distance: z.number(),
  goods_description: z.string().nullish(),
  height: z.number(),
  id: z.number(),
  international: z.boolean(),
  load_date: z.coerce.date().nullish(),
  notes: z.string().nullish(),
  origin_distance: z.number().nullish(),
  pallets: z.number().nullish(),
  ready: z.boolean(),
  registration_plates: z.string().nullish(),
  source: z.string(),
  temperature: z.number().nullish(),
  transit_time: z.number().nullish(),
  unload_date: z.coerce.date().nullable(),
  updated_at: z.string(),
  urgent: z.boolean(),
  weight: z.string().nullish(),
  width: z.number().nullish(),
})

export const GetLoadTypeSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
})

export const GetPackagingTypeSchema = z.object({
  alias: z.string().optional(),
  id: z.number(),
  title: z.string(),
})

export const GetRequirementsSchema = z.object({
  adr: z.boolean(),
  dvs: z.boolean(),
  waste_license: z.boolean(),
})
